<template>
  <div class="vehicle-maintenance-main">

    <div class="box">
      <Dropdown placeholder="Services" :selectedObject.sync="data.services" :items="data.servicesItems" :search.sync="data.servicesSearch" 
        :isDisabled="viewMode" :isRequired="true"/> 

      <div class="flex-row">
        <span style="padding: 30px 0;">Interval</span>
        <div class="check-section">
          <CheckBox title="Mileage" :isChecked.sync="data.IsMileage" :isDisabled="viewMode" />
          <CheckBox title="Month" :isChecked.sync="data.IsMonths" :isDisabled="viewMode" />
          <CheckBox title="Days" :isChecked.sync="data.IsDays" :isDisabled="viewMode" />
          <CheckBox title="Whichever Come First" :isChecked.sync="data.IsWhicheverComesFirst" :isDisabled="viewMode" />
        </div>
      </div> 
      
      <div class="flex-row" style="padding: 0 80px;">
        <Input placeholder="Mileage (KM)" :inputValue.sync="data.mileage_km" :isDisabled="viewMode" style="padding-right: 10px;"/> 
        <Input placeholder="Duration" :inputValue.sync="data.duration" :isDisabled="viewMode" /> 
      </div>

      <div class="flex-row">
        <span style="padding: 30px 0;">Occurence</span>
        <div class="check-section" style="margin-left: 9px;">
          <CheckBox title="Once Only" :isChecked.sync="data.IsOnceOnly" :isDisabled="viewMode" />
          <div style="display: flex;">
            <CheckBox title="Routine until" :isChecked.sync="data.IsRountine" :isDisabled="viewMode" />
            <DateTimePicker title="" :showTime="false" style="justify-content: flex-start; padding-left: 5px;" :value.sync="data.routineDate" :isDisabled="!data.IsRountine" />
          </div>
        </div>
      </div> 

      <Input placeholder="Remark" :inputValue.sync="data.maintenance_remark" :isDisabled="viewMode" />

      <div class="task-section">
        <span>Task List</span>   
        <div class="flex-row" >
          <Dropdown placeholder="Services" :selectedObject.sync="data.tasklistservice" :items="data.tasklistserviceItems" :search.sync="data.tasklistserviceSearch" 
            :isDisabled="viewMode" style="margin-top: 10px; width: calc(100% - 250px);"/>
          <button @click="delClicked" style="position: absolute; right: 35px; margin: 5px 10px; ">-</button>
          <button @click="addClicked" style="position:absolute; right: 75px; margin: 5px 10px;">+</button>
        </div>

        <div class="flex-row" >
          <Input placeholder="Remark" :inputValue.sync="data.taskService_remark" :isDisabled="viewMode" style="width: calc(100% - 250px);"/>
          <div class="button-section">
            <Input v-if="!viewMode" textType="file" placeholder="Browse" style="margin-bottom: 5px" @fileChanged="attachmentsChanged" multiFile="true"
              ref="att" />
          </div>
        </div>
      </div>

      <Tabulator class="maintenance-tabulator1" style="height: unset" tableID="tasklistattachmentTable" :tableData="data.maintenance_attachmentItems" :multiSelect="-1"
        :selectedRow.sync="selectedAttachments" :hideColumns="[ 'File Type' ]" />
    </div>

    <Tabulator class="maintenance-tabulator" style="height: unset" tableID="serviceTable" :tableData="data.serviceData" :multiSelect="1" :selectedRow.sync="selectedService"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import Dropdown from '@/components/Dropdown.vue';
import CheckBox from '@/components/CheckBox.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Input, Dropdown, CheckBox, DateTimePicker, Tabulator
  },
  props: {
    data: { type: Object, default: function() { return {} } },
    viewMode: { type: Boolean, default: false },

    selectedService: { type: Array, default: function() { return [] } },
    attachments: { type: String, default: ''},
    selectedAttachments: { type: String, default: ''},
  },
  methods: {
    addClicked: function() {
      if (this.attachments.length == 0) {
        this.$showAlert('error', 'Error', 'No file selected');
      } else {
        for (var i = 0; i < this.attachments.length; i++) {
          var reader = new FileReader();
          reader.readAsDataURL(this.attachments[i]);
          var current = this.attachments[i];

          reader.onload = () => {
            console.log('test');
            this.data.maintenance_attachmentItems.push({
              'FileName': current.name,
              'Remarks': this.data.taskService_remark,
              'File Type': current.type,
              'Base64File': reader.result.split(',')[1]
            });
          };
        }

        // this.$refs.att.clearFiles();
        this.data.taskService_remark = '';
      }
    },
    delClicked: function() {
      if (this.selectedAttachments.length == 0) {
        this.$showAlert('error', 'Error', 'No attachment selected to delete');
      } else {
        console.log(this.selectedAttachments);
        this.selectedAttachments.forEach((s) => {
          var deleteIndex = this.data.maintenance_attachmentItems.indexOf(s);
          this.data.maintenance_attachmentItems.splice(deleteIndex, 1);
        });
      }
    },
    attachmentsChanged: function(e) {
      this.attachments = e;
    }
  },
  mounted() {
  },
  watch: {
    selectedService: function() {
      if(this.selectedService.length >= 1){
        this.data.duration = this.selectedService[0].Duration ? this.selectedService[0].Duration.trim() : null;
        this.data.servicesSearch = this.selectedService[0].ServiceCode ? this.selectedService[0].ServiceCode.trim() : null;
        this.data.tasklistserviceSearch = this.selectedService[0].Task ? this.selectedService[0].Task.trim() : null;
        this.data.maintenance_remark = this.selectedService[0].Remark ? this.selectedService[0].Remark.trim() : null;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.box{
  border: 1px solid darkgrey;
  padding: 15px;
  margin: 15px;
}

.flex-row {
  display: flex;
}

.check-section{
  border: 1px solid darkgrey;
  padding: 15px;
  margin: 15px;
  display: flex;
  width: 100%;

   > * {
    flex-grow: 1;
    margin-right: 5px;
  }
}

.task-section{
  border: 1px solid darkgrey;
  border-radius: 3px;
  margin-top: 20px;
  padding: 15px;

  span{
    margin-top: -26px;
    position: absolute;
    background-color: #ffffffff;
    font-weight: bold;
    padding: 0 5px 0 5px;
    width: auto;
    height: 20px;
  }
}

.button-section{
  position: absolute;
  right: 35px; 
  margin: 0px 10px;
}

.maintenance-tabulator {
  height: calc(100% - 95px) !important;
}

</style>